import React from 'react';
import Form from '../../../common/masterform/Form';
import formConfig from './formConfig';

export default function SimulationTemplateOverview() {
    return <Form formId="simulation-template" config={formConfig}/>
}


